var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailedCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8048 30.2162C14.8305 32.6116 17.2421 33.7619 20 33.7619C22.7477 33.7619 25.2133 32.6131 27.3515 30.2162H31.6923C33.7092 30.2162 35.5362 31.0346 36.8603 32.3573C38.1815 33.68 39 35.507 39 37.5239V44.6489C39 45.8605 38.5089 46.9567 37.7153 47.7503C36.9217 48.5424 35.8255 49.0335 34.6154 49.0335H5.38462C4.17446 49.0335 3.07831 48.5424 2.28469 47.7503C1.49108 46.9567 1 45.8605 1 44.6489V37.5239C1 35.507 1.81846 33.68 3.13969 32.3573C4.46238 31.0346 6.28931 30.2162 8.30769 30.2162H12.8048Z",
    stroke: "#34303D",
    strokeWidth: 1.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 25.2995C26.7102 25.2995 32.1499 19.8599 32.1499 13.1498C32.1499 6.43964 26.7102 1 20.0001 1C13.29 1 7.85034 6.43964 7.85034 13.1498C7.85034 19.8599 13.29 25.2995 20.0001 25.2995Z",
    stroke: "#34303D",
    strokeWidth: 1.77
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5051 19.9925C14.5282 17.2682 17.2905 15.3784 20.37 15.3784C23.3077 15.3784 25.5614 17.4655 26.6765 19.9925",
    stroke: "#00D1D2",
    strokeWidth: 1.77,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedCode);
export default __webpack_public_path__ + "static/media/failedCode.9a055c4383c972cd9ab8a1649b7d4fdf.svg";
export { ForwardRef as ReactComponent };